export const MastercardBadgeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="30" viewBox="0 0 46 30" fill="none">
    <rect width="46" height="30" rx="6" fill="#18181C" />
    <circle cx="19.5" cy="15" r="7" fill="#EB001B" />
    <circle cx="26.5" cy="15" r="7" fill="#F79E1B" />
    <path d="M23 9.42a6.99 6.99 0 0 1 0 11.16 6.99 6.99 0 0 1 0-11.16Z" fill="#FF5F00" />
  </svg>
);
